(function (c2, $) {
  'use strict';

  /* ── Resources page (CMP-4140) ──
   *
   * A single server-side c2 DataTable over the ResourceStructured DB view
   * (merged Servers + Resources), styled like the standard per-type resource
   * list: a Show Filters panel + Order from Catalog button. c2.dataTables
   * builds the legacy DataTables params (sort, and the ColumnControl filters
   * on Type, Status, Owner, Group and Added) from data-table-source; the
   * filter-panel selections (c2.dataTables.addListFilters -> filters_selected,
   * which includes the admin-only "Show Internal Only" toggle) are added to
   * them here.
   */

  function initDataTable($table) {
    // Serialize the Show Filters panel (status/owner/group/show_historical/
    // show_internal_only) into filters_selected.
    $table.data('table-fnServerParams', function (aoData) {
      if (c2.dataTables.addListFilters) {
        c2.dataTables.addListFilters(aoData);
      }
    });
    c2.dataTables.init($table);
  }

  function init() {
    var $table = $('#all-resources-table');
    if (!$table.length) { return; }
    initDataTable($table);
    // Wire the Show Filters panel (lazy-loads the filter form, submit reloads).
    c2.dataTables.initListFilters('table#all-resources-table');
  }

  c2.allResources = { init: init };

})(window.c2, window.jQuery);
